// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1676022467108
      var cssReload = require("C:/Sources/nothegger.topwm/Nothegger.TopWM.Warehouse.Web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  